import { useRef, useState } from 'react'
import { Box, Paper, Tab, Tabs } from '@mui/material'

import {
  ConfiguredEntityInitialDataWrapper,
  GetConfiguredEntityParamsHandle,
} from '@pages/ConfiguredEntity'
import { SectionRowColumn } from '@pages/WindowsCreateOrEdit/types'

import { DisplayFormLoadInitialData } from '@components/DisplayForm'

import { ReturnTransformCommonParametersToValues } from '@helpers'
import { ENTITY, FLEXIBLE, FORM_TYPE, WINDOW_ENTITY, WINDOW_TABS_HEIGHT } from '@constants'
import { DialogWindowType, EntityType, GETAllVariables } from '@types'

import { LocalEventBus } from '../../../../events'

import { useSection } from './hooks/useSection'

type SectionProps = {
  dialogId: string
  data: SectionRowColumn
  commonParameters: ReturnTransformCommonParametersToValues
  dialogWindows: DialogWindowType[]
  currentDialogWindow: DialogWindowType<Record<string, unknown>> | undefined
  windowVariables?: GETAllVariables
  localEventBus: LocalEventBus
}

export const Section = ({
  dialogId,
  data: sectionData,
  commonParameters,
  dialogWindows,
  currentDialogWindow,
  windowVariables = [],
  localEventBus,
}: SectionProps) => {
  const [activeTab, setActiveTab] = useState(sectionData.tabs?.[0] ?? null)
  const [entity, setEntity] = useState<EntityType | null>(null)
  const viewRef = useRef<GetConfiguredEntityParamsHandle>(null)

  const { data, handlers } = useSection({
    activeTab,
    commonParameters,
    dialogWindows,
    currentDialogWindow,
    windowVariables,
    localEventBus,
  })

  const { updatedFilter } = data
  const { handleOpenForm, handleRowSelection } = handlers

  return (
    <Paper
      sx={{
        ...FLEXIBLE,
        p: 0.5,
        // borderRadius: 0,
        height: '100%',
      }}
    >
      <Tabs
        allowScrollButtonsMobile
        scrollButtons='auto'
        value={activeTab}
        variant='scrollable'
        sx={{
          '.MuiButtonBase-root': {
            paddingY: 1.25,
          },
          minHeight: 20,
          height: 20,
          flexShrink: 0,
        }}
        onChange={(event, value) => setActiveTab(value)}
      >
        {sectionData.tabs.map(tab => (
          <Tab
            key={tab.id}
            label={tab.title}
            value={tab}
            sx={{
              maxWidth: 500,
              minHeight: 20,
              height: 20,
              background: theme => theme.palette.background.selectedRow,
            }}
          />
        ))}
      </Tabs>
      <Box sx={{ height: `calc(100% - ${WINDOW_TABS_HEIGHT}px)` }}>
        {activeTab?.entityType === WINDOW_ENTITY.VIEW && (
          <ConfiguredEntityInitialDataWrapper
            key={activeTab.entityId}
            ref={viewRef}
            isViewDialogWindow
            defaultFilter={updatedFilter}
            dialogId={dialogId}
            entity={entity}
            entityCode={activeTab.entityCode}
            entityId={activeTab.entityId}
            outerEventBus={localEventBus}
            path={activeTab.entityId}
            showQuickSearch={true}
            title={activeTab.entityTitle}
            type={ENTITY.VIEW}
            outerData={{
              variables: windowVariables,
            }}
            onOpenForm={handleOpenForm}
            onRowSelection={handleRowSelection}
            onSetEntity={value => setEntity(value)}
          />
        )}
        {activeTab?.entityType === WINDOW_ENTITY.FORM && (
          <DisplayFormLoadInitialData
            isFormDialogWindow
            isSectionWindow
            dialogId={dialogId}
            passedParams={{
              objectCode: activeTab.objectCode,
              formCode: activeTab.entityCode as string,
              viewCode: '',
              path: activeTab.entityId?.toString() as string,
              event: FORM_TYPE.CREATE,
              globalId: activeTab.id,
              entityType: ENTITY.VIEW,
              viewId: activeTab.entityId,
            }}
            resetFieldsAfterCreate
            //onChangeDirty={this.updateDirty}
          />
        )}
      </Box>
    </Paper>
  )
}
